const _ = require('lodash');

class CorporateHeaderController {
    constructor($window, $state, analyticsService) {
        this.$window = $window;
        this.$state = $state;
        this.analyticsService = analyticsService;
    }

    /**
     * The shopping link is active at all times EXCEPT for when we
     * are on store locator OR the rewards page in Discover.
     *
     * @returns {boolean}
     *
     * @memberOf CorporateHeaderController
     */
    isShoppingActive() {
        const exceptStates = [
            { state: 'shop.locator' },
            { state: 'shop.inspiration.parent', params: { parent: 'woolworths-rewards' } },
        ];

        return !(_.some(exceptStates, s => this.$state.is(s.state, s.params)));
    }

    pushToAnalytics(eventValue, eventLabel) {
        this.analyticsService.push({
            data: {
                event: {
                    category: 'Header',
                    value: eventValue,
                    label: eventLabel,
                },
                trackingType: 'link',
            },
            type: this.analyticsService.mapperTypes.customEvent.linkClick,
        });
    }
}

const corporateHeaderComponentDefinition = {
    bindings: {
        classModifier: '@?',
    },
    controller: ['$window', '$state', 'AnalyticsService', CorporateHeaderController],
    template: require('./corporate-header.component.html').trim(),
};

module.exports = {
    corporateHeaderComponentDefinition,
    CorporateHeaderController,
};



// WEBPACK FOOTER //
// ./src/shop/header/corporate-header.component.js